import React, { useEffect, useState } from "react";
import styled from "styled-components/native";
import { Linking, Platform, TouchableOpacity } from "react-native";
import {
  Typography,
  Button,
  TextInput,
  Divider,
  Stack,
  CircleCheckmark,
  Spacer,
  Box,
} from "digiwash-components";
import useEditProfile from "../../hooks/useEditProfile";
import { color } from "@sloth-system/styled-utils";
import { useToast } from "digiwash-components";
import useCart from "../../ducks/cart/hooks/useCart";
import { useHomePageContent } from "../../hooks/useHomePageContent";

let UserInfoInput = styled(TextInput)`
  background-color: ${color("neutrals.200")};
  border: 0;
  border-radius: 16px;
`;

interface PropTypes {}

function CompleteStep(props: PropTypes) {
  let [name, setName] = useState("");
  let [lastName, setLastName] = useState("");
  let [agreement, setAgreement] = useState(true);
  let { loading, editProfile } = useEditProfile();
  let toast = useToast();
  let { retrieve: homePageContentRetrieve, data: homePageContentData } =
    useHomePageContent();
  let { coupon } = useCart();

  useEffect(() => {
    homePageContentRetrieve();
  }, []);

  return (
    <Box pt="xxl" pb="l" px="l">
      <Typography ff="mainBold" fs="l" color="common.black">
        ثبت نام
      </Typography>
      <Divider size="xxl" />
      <Box px="m">
        <Typography color="text.dark">لطفا نام خود را وارد کنید</Typography>
      </Box>
      <Divider size="m" />
      <UserInfoInput onChangeText={setName} value={name} placeholder="نام" />
      <Divider size="l" />
      <Box px="m">
        <Typography color="text.dark">
          لطفا نام خانوادگی خود را وارد کنید
        </Typography>
      </Box>
      <Divider size="m" />
      <UserInfoInput
        onChangeText={setLastName}
        value={lastName}
        placeholder="نام خانوادگی"
      />
      <Divider size="l" />

      <Stack>
        <TouchableOpacity
          onPress={() => {
            setAgreement(!agreement);
          }}
        >
          <Stack>
            <CircleCheckmark isSelected={agreement} />
            <Spacer size="m" />
            <Stack>
              <Typography
                accessibilityRole="link"
                href="https://digiwash.ir/%d9%82%d9%88%d8%a7%d9%86%db%8c%d9%86-%d9%88-%d9%85%d9%82%d8%b1%d8%b1%d8%a7%d8%aa/"
                target="_blank"
                color="primary.main"
                onPress={() => {
                  if (Platform.OS !== "web") {
                    Linking.openURL(
                      "https://digiwash.ir/%d9%82%d9%88%d8%a7%d9%86%db%8c%d9%86-%d9%88-%d9%85%d9%82%d8%b1%d8%b1%d8%a7%d8%aa/"
                    );
                  }
                }}
              >
                شرایط و قوانین
              </Typography>
              <Spacer size="s" />
              <Typography color="common.black">دیجی‌واش را میپذیرم.</Typography>
            </Stack>
          </Stack>
        </TouchableOpacity>
      </Stack>
      <Divider size="l" />
      <Button
        outline
        onPress={() => {
          editProfile({
            first_name: name,
            last_name: lastName,
          })
            .then(() => {
              toast.show("پروفایل با موفقیت به روز شد.", {
                data: { type: "success" },
              });
              if (
                !!homePageContentData &&
                !!homePageContentData.promotionNewUsers &&
                !!homePageContentData.promotionNewUsers[0].code
              ) {
                coupon
                  .add(homePageContentData.promotionNewUsers[0].code)
                  .then(() => {
                    toast.show("کد تخفیف با موفقیت افزوده شد.", {
                      data: { type: "success" },
                    });
                  });
              }
            })
            .catch(() => {
              toast.show("مشکلی در به‌روزرسانی پروفایل پیش آمده است.", {
                data: { type: "danger" },
              });
            });
        }}
        disabled={!agreement || !name || !lastName || loading}
      >
        تایید اطلاعات
      </Button>
    </Box>
  );
}

export default CompleteStep;
